// React/Redux
import React, { Component } from "react";
import { connect } from "react-redux";

// Material UI
import ButtonBase from "@material-ui/core/ButtonBase";

// PAC
import { salesStatuses } from "./salesStatuses";

class ProspectsArrow extends Component {
  state = {
    prospects: []
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const { prospects } = this.props;

      this.setState({ prospects });
    }
  }

  onClick = e => {
    e.preventDefault();
    this.props.onClick("Prospects", salesStatuses.PROSPECT);
  };

  render() {
    return (
      <div className="arrow-container">
        <div className="arrow-btn arrow-prospects">
          <ButtonBase onClick={this.onClick}>
            <span className="arrow-btn-label">
              {this.state.prospects.length} <br />
              prospects
            </span>
          </ButtonBase>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    prospects: state.salesActivity.prospects
  }
}

export default connect(mapStateToProps)(ProspectsArrow);
